import { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { Users } from "lucide-react";

// PATCH 36 Me16 — a plain multi-admin presence signal. Heartbeats every 20s for a scope
// (a project id, or "command-center"); shows "X is also here" when others are active.
export default function PresenceBar({ scope, testid = "presence-bar" }) {
  const [others, setOthers] = useState([]);
  const beat = useRef(null);

  useEffect(() => {
    if (!scope) return undefined;
    let stop = false;
    const ping = () => { api.post("/polish/presence/beat", { scope }).catch(() => {}); };
    const pull = () => api.get(`/polish/presence/${encodeURIComponent(scope)}`)
      .then((r) => { if (!stop) setOthers(r.data.others || []); }).catch(() => {});
    ping(); pull();
    beat.current = setInterval(() => { ping(); pull(); }, 20000);
    return () => { stop = true; clearInterval(beat.current); };
  }, [scope]);

  if (!others.length) return null;
  const names = others.map((o) => o.name).filter(Boolean);
  const label = names.length === 1
    ? `${names[0]} is also here`
    : `${names.slice(0, 2).join(", ")}${names.length > 2 ? ` +${names.length - 2}` : ""} are also here`;
  return (
    <div data-testid={testid} className="k-badge" style={{ marginBottom: 12, fontSize: 12 }}>
      <Users size={13} aria-hidden="true" /> {label}
    </div>
  );
}
